import { isSSR } from '@sitecore-search/common';
import { Actions, PageController, init as initCore } from '@sitecore-search/core';
import { CONTAINER_SELECTOR } from './domUtils.js';
import WidgetsMonitor from './widgetsMonitor.js';
export const init = (options) => {
    const { autoIncludeNewWidgets = false, autoIncludeWidgets = true, uri } = options || {};
    if (isSSR()) {
        if (uri) {
            PageController.getContext().setPageUri(uri);
        }
        initCore();
        return;
    }
    PageController.getContext().setPageUri(uri || window.location.pathname);
    if (autoIncludeNewWidgets) {
        WidgetsMonitor.start();
    }
    if (autoIncludeWidgets) {
        const autoIncludedWidgets = Array.from(document.querySelectorAll(
        // rfkid elements that are not inside rfkid_container or are a rfkid_container
        `:not(${CONTAINER_SELECTOR}) > [data-rfkid]:not(${CONTAINER_SELECTOR})`));
        const widgets = autoIncludedWidgets
            // removes duplicates
            .filter((x, i, a) => a.indexOf(x) === i)
            .map((node) => {
            const rfkId = node.dataset.rfkid;
            const entity = node.dataset.entity;
            return { rfkId, entity, node };
        });
        if (widgets.length) {
            setTimeout(() => {
                PageController.getDispatcher().dispatch({
                    type: Actions.FOUND_WIDGETS,
                    payload: { widgets },
                });
            }, 0);
        }
    }
    initCore();
};
